import React, {Component} from 'react';
import Swal from 'sweetalert2';
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import {UncontrolledTooltip} from 'reactstrap';

class NoteList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            notes: [],
            isEdit: false,
            filterNotes:[],
            nonFilterNotes:[]
        };
        this.addNote = this.addNote.bind(this);
        this.removeNote = this.removeNote.bind(this);
        this.onChangeNote = this.onChangeNote.bind(this);
        this.validateField = this.validateField.bind(this);
        this.checkPrevNoteUpdate = this.checkPrevNoteUpdate.bind(this);
    }

    componentWillMount() {
        let self = this;
        let notes = self.props.notes;
        self.decodeNoteValue(notes);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.checkPrevNoteUpdate(prevProps)
    }


    addNote(e) {
        let notes = deepCopyObject(this.state.notes);
        notes.push({recordId: null, note: ''});
        this.props.listener(notes);
        this.setState({notes});
    }

    removeNote(e, index) {
        let notes = deepCopyObject(this.state.notes);
        if (notes.length > 1) {
            notes.splice(index, 1);
            this.props.listener(notes);
            this.setState({notes});
        } else {
            Swal({
                title: "Uyarı",
                text: ("En az bir adet not satırı bulunmalıdır."),
                type: 'error',
                confirmButtonText: 'Tamam'
            });
        }
    }

    onChangeNote(e, index) {
        let self = this;
        let filterNotes = deepCopyObject(self.state.filterNotes);
        filterNotes[index].note = e.target.value;
        this.props.listener(self.mergeNotes(filterNotes));
        this.setState({filterNotes, isEdit: true});
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.props.error;
        error = Object.assign(error, {[id]: result});
        this.props.errorListener(error);
    }

    validateClass(id) {
        let error = this.props.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.props.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.error !== nextProps.error) {
            this.setState({error: nextProps.error});
        }

        if (nextProps.manual) {
            this.setState({notes: nextProps.notes, error: {}});
            this.props.isManual(false);
            this.props.errorListener({});
        }
    }

    /**
     * @description  encoded notes are decoded by this function
     * @param {Notes} notes
     * @return {void} void
     */
    decodeNoteValue(notes) {
        let self = this;
        let isEdit = false;
        let filterNotes = [];
        let nonFilterNotes = [];
        if(notes.length === 0){
            filterNotes = notes;
        }else{
            const splitResult = self.splitNotes(notes);
            filterNotes = splitResult.filterNotes;
            nonFilterNotes = splitResult.nonFilterNotes;
        }

        for (const index in filterNotes) {
            if (filterNotes[index].note.includes("%%5Q&McXF&9Tgn&DeW%%")) {
                isEdit = true;
                filterNotes[index].note = filterNotes[index].note.replaceAll("%%5Q&McXF&9Tgn&DeW%%", "Yalnız:");
            }
            if (filterNotes[index].note.includes("%%11Gm&p7hwv&lNIff%%")) {
                isEdit = true;
                filterNotes[index].note = filterNotes[index].note.replaceAll("%%11Gm&p7hwv&lNIff%%", "istinaden");
            }
            if (filterNotes[index].note.includes("%%63FA&p1qca&KrzYY%%")) {
                isEdit = true;
                filterNotes[index].note = filterNotes[index].note.replaceAll("%%63FA&p1qca&KrzYY%%", "Yalnız");
            }
        }
        self.setState({filterNotes,nonFilterNotes, isEdit})
    }

    splitNotes(notes){
        let self = this;
        let nonFilterNotes = [];
        let filterNotes = [];
        for (const note in notes) {
            if(self.checkForbiddenWord(notes[note].note))
                nonFilterNotes.push(notes[note]);
            else
                filterNotes.push(notes[note]);
        }
        return {nonFilterNotes,filterNotes}
    }

    checkForbiddenWord(note){
        let self = this;
        let result = false;
        const words = self.props.type ==="SMM" ?
            ['SGK_','FATURATIPI:','Yalnız:','Yalnız','istinaden']
            :
            ['SGK_','FATURATIPI:','Yalnız:','istinaden']

        for (const wordsKey in words) {
            if ((note.indexOf(words[wordsKey]) !== -1))
                result = true;
        }
        return result;
    }

    mergeNotes(filterNotes){
        let self = this;
        const nonFilterNotes = self.state.nonFilterNotes;
        return  nonFilterNotes.concat(filterNotes);
    }

    checkPrevNoteUpdate(prev){
        let self = this;
        const notes = self.props.notes;
        const isEdit = self.state.isEdit;
        if(prev.notes !== notes && !isEdit ){
            self.decodeNoteValue(notes);
        }
    }

    render() {
        if (!this.state.filterNotes) return null;
        const tNotes = this.state.isEdit?
                this.state.filterNotes.filter(note =>
                    (note.note.indexOf('SGK_') === -1 &&
                        note.note.indexOf('FATURATIPI:') === -1))
            :
            this.state.filterNotes.filter(note => (note.note.indexOf('SGK_') === -1 &&
                note.note.indexOf('FATURATIPI:') === -1 &&
                note.note.indexOf('Yalnız:') === -1 &&
                note.note.indexOf('Yalnız') === -1 &&
                note.note.indexOf('istinaden') === -1));
        return (
            <div>
                {
                    tNotes.map((trdDocVoucherNote, index) =>
                        <div className={" row" + this.validateClass("note_" + index)} key={index}>
                            {
                                <textarea
                                    id={"note_" + index}
                                    data-vlength="0,5000"
                                    style={{width: '100%', paddingBottom: 'inherit'}}
                                    onBlur={this.validateField}
                                    value={trdDocVoucherNote.note}
                                    onChange={(e) => this.onChangeNote(e, index)}
                                    rows={this.props.rows ? this.props.rows : "7"}
                                />
                            }
                            {this.validateMessage("note_" + index) !== "" &&
                            <UncontrolledTooltip placement="right" target={"note_" + index} delay={0}>
                                {this.validateMessage("note_" + index)}
                            </UncontrolledTooltip>}

                            {/*<div className="col-sm-1">*/}

                            {/*BUTONLAR OLMAYACAK*/}
                            {/*<button type="button" rel="tooltip" onClick={(e)=>this.removeNote(e,index)}*/}
                            {/*style={{marginLeft:'-25px' ,marginTop: '15px'}}*/}
                            {/*data-placement="left" title="" className="Btn temizle" data-original-title="Notu Sil">*/}
                            {/*/!*<i className="now-ui-icons ui-1_simple-remove"></i>*!/*/}
                            {/*</button>*/}
                            {/*</div>*/}
                        </div>
                    )
                }
                <div className="row">
                    <div className="col-sm-12">
                        {/*BUTONLAR OLMAYACAK*/}
                        {/*<button type="button" rel="tooltip" onClick={(e)=>this.addNote(e)}*/}
                        {/*style={{background:'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}*/}
                        {/*data-placement="left" title="" className="Btn ekle" data-original-title="Notu Ekle">*/}
                        {/*</button>*/}
                    </div>
                </div>
            </div>
        );
    }
}

export default NoteList;